'use client';

import {Ribbon} from '@udemy-v2/react-notice-components';
import {useI18n} from '@udemy-v2/i18n';
import classNames from 'classnames';

import styles from './community-plus-ribbon.module.scss';

export interface CommunityPlusRibbonProps {
    className?: string;
}

export function CommunityPlusRibbon({className}: CommunityPlusRibbonProps) {
    const {gettext} = useI18n();

    return (
        <Ribbon className={classNames(styles.ribbon, className)}>
            {gettext('Community +')}
        </Ribbon>
    );
}
